import React from "react";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { HeaderActions } from "../../../common/ui/layout/header/HeaderActions";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { ordersRoutes } from "../../OrdersRoutes";

export const OnPremOrderDashboardHeader: React.VFC = () => {
    return (
        <PageHeader>
            <HeaderBreadcrumb routes={ordersRoutes} />
            <HeaderActions></HeaderActions>
        </PageHeader>
    );
};
